/*
*
* File JS per la Homepage
*
*/

// IMPORT LIBRERIE ESTERNE
//--------------------------------------------------------------------//

// import ScrollMagic from 'ScrollMagic';
// import 'debug.addIndicators';

//--------------------------------------------------------------------//

// IMPORT COMPONENTI
//--------------------------------------------------------------------//

import readmore from 'components/readmore/readmore';
import blockStartHp from 'components/block-start-hp/block-start-hp';
import blockImgTextCta from 'components/block-img-text-cta/block-img-text-cta';
import blockWines from 'components/block-wines/block-wines';
import carouselGallery from 'imComponents/carousel-gallery/carousel-gallery';
import form from 'components/form/form';
import accordion from 'imComponents/accordion/accordion';


//--------------------------------------------------------------------//

// IMPORT STILE SPECIFICO PAGINA
//--------------------------------------------------------------------//

import './homepage.scss';

//--------------------------------------------------------------------//


// INIT COMPONENTI
//--------------------------------------------------------------------//

carouselGallery();
readmore();
blockWines();
accordion();

//--------------------------------------------------------------------//